var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.97,
    height: 15,
    viewBox: "0 0 16.97 15",
    "data-prefix": "iagzr8tmy",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "1Telegram.svg",
    d: "M15.84.128L.62 6.147c-.83.251-.8 1.11-.19 1.316l3.82 1.243 1.46 4.673c.17.511.32.7.62.708a1 1 0 0 0 .77-.422c.39-.38.98-.977 1.91-1.923l3.97 3.061c.73.421 1.26.2 1.44-.708L16.9 1.246C17.17.13 16.54-.2 15.84.128zM4.85 8.421l8.67-5.682c.42-.3.56.035.36.265L6.69 9.765l-.37 3.374z",
    fillRule: "evenodd",
    className: "path-ijt6eaqcb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.7e9e7739f057f324eec6594b9e1d7aeb.svg";
export { ForwardRef as ReactComponent };